import React from 'react';
import Menu from '../Menu';
import IndexStyle from './style.scss';

class Header extends React.Component {

	render() {
		return (
			<div className={IndexStyle.headerToolbarWrapper}>
				<Menu/>
			</div>
		)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./components/Header/index.js